import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["label"]
  static values = {
    text: String
  }

  async copy(event) {
    event.preventDefault()
    try {
      await navigator.clipboard.writeText(this.textValue)
      if (this.hasLabelTarget) {
        this.labelTarget.textContent = "Copiado"
        setTimeout(() => {
          this.labelTarget.textContent = "Copiar"
        }, 2000)
      }
    } catch (e) {
      if (this.hasLabelTarget) {
        this.labelTarget.textContent = "Error"
        setTimeout(() => {
          this.labelTarget.textContent = "Copiar"
        }, 2000)
      }
    }
  }
}
